import type { IGroupItemView } from '../types';

export function getGroupMessagePreview(group: IGroupItemView, t: (key: string) => string): string {
  const raw = typeof group.lastMessage === 'string' ? group.lastMessage.trim() : '';
  const taskType = Number(group.lastMessageData?.type);
  if (taskType === 6 || taskType === 8) {
    const className =
      typeof group.lastMessageData?.className === 'string' ? group.lastMessageData.className.trim() : '';
    const title = taskType === 6 ? className || t('GroupScreen.CheckInPreview') : t('GroupScreen.SignupPreview');
    const sender =
      (typeof group.lastMessageUserName === 'string' && group.lastMessageUserName.trim()) ||
      (raw.includes(': ') ? raw.slice(0, raw.indexOf(': ')) : '');
    return `${sender ? `${sender}: ` : ''}[${title}]`;
  }

  // Both sender!image!… and sender: !image!… are used by the clients.
  const attachment = raw.match(/^(.*?)!\s*(image|audio|file|contact)!/);
  if (attachment) {
    const labels: Record<string, string> = {
      image: 'Chatroom.Image',
      audio: 'Chatroom.AudioMessage',
      file: 'Chatroom.File',
      contact: 'Chatroom.ContactCard'
    };
    const sender = attachment[1].replace(/:\s*$/, '').trim();
    return `${!group.isOneOnOneGroup && sender ? `${sender}: ` : ''}[${t(labels[attachment[2]])}]`;
  }
  const text = raw.replace(/\\n|\s+/g, ' ').trim();
  return group.isOneOnOneGroup && text.includes(': ') ? text.slice(text.indexOf(': ') + 2) : text;
}

export function formatGroupMessageTime(timestamp: unknown): string {
  if (typeof timestamp !== 'number' || !Number.isFinite(timestamp) || timestamp <= 0) return '';
  const date = new Date(timestamp * 1000);
  if (!Number.isFinite(date.getTime())) return '';
  const now = new Date();
  const pad = (value: number) => String(value).padStart(2, '0');
  if (now.toDateString() === date.toDateString()) return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
  const monthDay = `${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  return now.getFullYear() === date.getFullYear() ? monthDay : `${date.getFullYear()}-${monthDay}`;
}
